/*
 * @Author: guoyu
 * @Date: 2021-04-27 17:13:42
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2023-09-20 18:35:01
 * @Description: file content
 */
import Vue from 'vue'
import LoginTemplate from './index.vue'
import GrowingLoginTemplate from './ref-index.vue'
import store from '@/store/index'
import router from '@/router/index'
const LoginConstructor = Vue.extend(LoginTemplate)
const GrowingLoginConstructor = Vue.extend(GrowingLoginTemplate)

let loginInstance = null
let lastConstructor = null
let lastOptions = null

const Login = (options = {}) => {
  const userInfo = store.state.app.userInfo
  if (userInfo) {
    return Promise.resolve()
  }
  let Handler = LoginConstructor
  const invStr = sessionStorage.getItem('INVITE_UNIQUE')
  if (invStr) {
    const invObj = JSON.parse(invStr)
    if (location.href.includes(invObj.href)) {
      delete invObj.href
      Object.assign(options, invObj)
    } else {
      options.inviterUnique = invObj.inviterUnique
    }
  } else if (location.href.includes('isHome')) {
    try {
      if (location.href.split('?')[1].split('&')[1].split('=')[1]) options.isHome = true
    } catch (e) {
      console.log(e)
    }
  }
  if (options && options.isRef) {
    Handler = GrowingLoginConstructor
  }
  if (!loginInstance || lastConstructor !== Handler || lastOptions && lastOptions.chatAvatar || lastOptions && lastOptions.isSix) {
    loginInstance = new Handler({
      store,
      router,
      el: document.createElement('div')
    })
  }

  lastConstructor = Handler
  lastOptions = options
  // 手機版默認使用手機登錄
  const data = window.innerWidth < 600 || options.phoneLoginDialog?{phoneLoginDialog:true}:{ visible: true }
  Object.assign(loginInstance.$data, options, data)

  return new Promise(resolve => {
    loginInstance.success = (params) => {
      resolve(params)
    }

    document.body.appendChild(loginInstance.$el)
  })
}

export default Login